import React from "react";
import Testimonial from "../common/testimonial/Testimonial";
import { testimonialSections } from "../utils/testimonials";

function TestimonialsSection() {
  
  return (
    <section>
      <div className=" mx-auto wrapper wrapper-terminal py-20 pb-0">
        <h2 className="testimonial-title text-center mb-20">
          <span
            className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400"
            style={{ color: "#6E4CD1" }}
          >
            Flexible{" "}
          </span>
          for everyone needs
        </h2>
        <div className="flex-col items-center md:flex md:flex-row justify-center md:items-start">
          {testimonialSections.map((section, index) => (
            <Testimonial
              key={index}
              section={section}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;
